import { Builder } from 'components/minute/builders/v2/Builder';
import { useDirectMarkerUpdates } from 'components/minute/builders/v2/useDirectMarkerUpdates';
import { useCreateWorldMarkerV2 } from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { ICoordinates } from 'libs/types/map/mapTypes';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';

export const PolygonBuilder = () => {
    const ctxEdit = useContext(CtxEdit);
    const createWorldMarkerV2 = useCreateWorldMarkerV2();
    const directMarkerUpdates = useDirectMarkerUpdates();

    const updateMarkerDirectly = (markerId: string, newCoordinates: ICoordinates[]) => {
        directMarkerUpdates.updatePolygon(markerId, newCoordinates, 'regular', {
            closePolygon: true
        });
    };

    return (
        <Builder
            updateMarkerDirectly={updateMarkerDirectly}
            shouldBeClosedPolygon={true}
            createWorldMarker={(coordinate) => {
                const marker = createWorldMarkerV2.createPolygon(coordinate.lat, coordinate.lng);
                return { markerId: marker.id };
            }}
            onFinished={(marker) => {
                ctxEdit.markerCreation.finish(marker);
            }}
        />
    );
};
